import { TeamServiceTreeMapping } from "Core/oRPC";
import { TeamServiceTreeMappingBatchItem } from "Core/oRPC/APIs/icmKustoApi";

import { TeamOwnedService } from "./TeamServiceTreeMappings.types";

export {
    getTeamBatchSelectors as getTeamServiceTreeMappingBatchRequest,
    hasTeamBatchSelectors as hasTeamServiceTreeMappingSelectors
} from "./TeamBatchSelectors.utils";

export const getValidTeamServices = (serviceMappings?: TeamServiceTreeMapping[]) => {
    const servicesById = new Map<string, TeamOwnedService>();

    serviceMappings?.forEach((mapping) => {
        const id = mapping.Id?.trim();
        const displayName = mapping.DisplayName?.trim();

        const normalizedId = id?.toLowerCase();

        if (id && displayName && normalizedId && !servicesById.has(normalizedId)) {
            servicesById.set(normalizedId, { Id: id, DisplayName: displayName });
        }
    });

    return [...servicesById.values()];
};

export const getTeamOwnedServiceNames = (serviceMappings?: TeamServiceTreeMapping[]) => {
    const serviceNames = new Map<string, string>();

    getValidTeamServices(serviceMappings).forEach(({ DisplayName }) => {
        const normalizedName = DisplayName.toLowerCase();
        if (!serviceNames.has(normalizedName)) {
            serviceNames.set(normalizedName, DisplayName);
        }
    });

    return [...serviceNames.values()];
};

export const getOwnedServicesByTeamId = (mappings?: TeamServiceTreeMappingBatchItem[]) => {
    const servicesByTeamId = new Map<string, TeamOwnedService[]>();

    mappings?.forEach((mapping) => {
        const teamId = mapping.TeamId?.trim();
        const serviceId = mapping.MappedServiceTreeId?.trim();
        const displayName = mapping.MappedServiceTreeName?.trim();

        if (teamId && serviceId && displayName && !servicesByTeamId.has(teamId)) {
            servicesByTeamId.set(teamId, [{ Id: serviceId, DisplayName: displayName }]);
        }
    });

    return servicesByTeamId;
};
